import { ApiPageType, ApiProject } from "@incendium/api";
import { locationService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchPageTypes = async (project: ApiProject) => {
  const pageTypes = await locationService.locationServiceListPageTypes({
    projectId: project.id as number,
  });
  return pageTypes.results || [];
};

export const usePageTypes = () => {
  const { state, setState } = useProjectSharedState("pageTypes", [], fetchPageTypes);

  return {
    pageTypes: state as ApiPageType[],
    setPageTypes: setState,
  };
};
